module.exports = __webpack_public_path__ + "static/img/stakeholdersEN.d411913.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stakeholdersEN.jpg
// module id = OenG
// module chunks = 1